import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Archive, RotateCcw } from "lucide-react";

const fmt = (s) => (s ? new Date(s).toLocaleString("ar-SA-u-nu-latn", { dateStyle: "short", timeStyle: "short" }) : "—");

export function PaymentsTrash({ onRestored }) {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState(null);

  const load = () => api.get("/admin/payments/trash").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { if (open) load(); }, [open]);

  const restore = async (p) => {
    try {
      await api.post(`/admin/payments/${p.id}/restore`);
      toast.success("تم استرجاع العملية");
      load();
      onRestored();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="outline" className="rounded-full gap-2" data-testid="payments-trash-btn"><Archive className="w-4 h-4" /> سلة المحذوفات</Button>
      </DialogTrigger>
      <DialogContent dir="rtl" className="max-w-2xl" data-testid="payments-trash-dialog">
        <DialogHeader><DialogTitle>سلة المحذوفات</DialogTitle></DialogHeader>
        <div className="max-h-[60vh] overflow-y-auto divide-y divide-border">
          {rows === null && <div className="py-8 text-center text-sm text-muted-foreground">جارٍ التحميل...</div>}
          {rows?.length === 0 && <div className="py-8 text-center text-sm text-muted-foreground" data-testid="trash-empty">السلة فارغة</div>}
          {rows?.map((p) => (
            <div key={p.id} className="py-3 flex items-center justify-between gap-3" data-testid={`trash-row-${p.id}`}>
              <div className="min-w-0">
                <div className="font-mono text-xs truncate" title={p.transaction_id}>{p.transaction_id || "—"}</div>
                <div className="text-sm font-semibold">{Number(p.amount || 0).toFixed(2)} ر.س · {p.kind === "repair" ? "إصلاح" : "سطحة"} · {p.customer_name}</div>
                <div className="text-xs text-muted-foreground">أُنشئت {fmt(p.created_at)} · حُذفت {fmt(p.hidden_at)}</div>
              </div>
              <Button size="sm" variant="outline" className="rounded-full gap-1.5 shrink-0" onClick={() => restore(p)} data-testid={`trash-restore-${p.id}`}>
                <RotateCcw className="w-4 h-4" /> استرجاع
              </Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
